import { Controller } from "@hotwired/stimulus"

// Store product page (TMS-1247, TMS-996): as the quantity stepper changes, asks the server how
// that many copies resolve into packs and shows it, with the total in the big price. The
// stepper always counts copies, so choosing a pack sets the stepper to the pack's size rather
// than switching units. The "1 Copy" choice (no tier id) is the selected one whenever the
// copies resolve to no pack at all.
export default class extends Controller {
  static targets = ["selector", "resolution", "tier", "price"]
  static values = { quoteUrl: String }

  disconnect() {
    clearTimeout(this.timer)
    this.abort?.abort()
  }

  changed(event) {
    clearTimeout(this.timer)
    const quantity = event.detail?.value
    this.timer = setTimeout(() => this.fetchQuote(quantity), 200)
  }

  chooseTier(event) {
    if (event.currentTarget.disabled || !this.hasSelectorTarget) return

    const quantity = parseInt(event.currentTarget.dataset.quantity, 10)
    const stepper = this.application.getControllerForElementAndIdentifier(this.selectorTarget, "quantity-selector")
    if (stepper) stepper.currentValue = quantity
  }

  async fetchQuote(quantity) {
    this.abort?.abort()
    this.abort = new AbortController()
    const url = new URL(this.quoteUrlValue, window.location.origin)
    url.searchParams.set("quantity", quantity)

    try {
      const response = await fetch(url, { headers: { Accept: "text/html" }, signal: this.abort.signal })
      if (!response.ok) return

      this.resolutionTarget.innerHTML = await response.text()
      this.markSelectedTiers()
    } catch (error) {
      if (error.name !== "AbortError") throw error
    }
  }

  markSelectedTiers() {
    const summary = this.resolutionTarget.querySelector("[data-selected-tier-ids]")
    const selected = (summary?.dataset.selectedTierIds || "").split(",").filter(Boolean)
    if (this.hasPriceTarget && summary?.dataset.total) this.priceTarget.textContent = summary.dataset.total

    this.tierTargets.forEach((tier) => {
      const id = tier.dataset.tierId
      const isSelected = id ? selected.includes(id) : selected.length === 0
      tier.classList.toggle("is-selected", isSelected)
      tier.setAttribute("aria-pressed", isSelected)
    })
  }
}
